import BaseLayout from '@/layouts/BaseLayout';
import '../styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import { ContactUS } from '@/app/pages/Contactus';
import { useScrollToTopOnRouteChange } from '@/hooks/scrolltotop';
import { Services } from '@/app/pages/Services';
import { AboutUS } from '@/app/pages/About Us';
import { PrivacyPolicy } from '@/app/pages/PrivacyPolicy';
import { TermsCondition } from '@/app/pages/TermsCondition';
import { ServicesAll } from '@/constants/ServicesAll';
import { CommonServicePage } from '@/components/services/CommonServicePage';
function App() {
  console.log('test test');
  return (
    <Router>
      <ScrollHandler />
      <Routes>
        <Route element={<BaseLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<ContactUS />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<AboutUS />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route
            path="/cleaning-services"
            element={<CommonServicePage currentService={ServicesAll[0]} />}
          />
          <Route
            path="/home-extensions"
            element={<CommonServicePage currentService={ServicesAll[1]} />}
          />
          <Route
            path="/gardening-services"
            element={<CommonServicePage currentService={ServicesAll[2]} />}
          />
          <Route
            path="/painting-services"
            element={<CommonServicePage currentService={ServicesAll[3]} />}
          />
          <Route
            path="/roofing-services"
            element={<CommonServicePage currentService={ServicesAll[4]} />}
          />

          <Route
            path="/plumbing-services"
            element={<CommonServicePage currentService={ServicesAll[5]} />}
          />
          <Route
            path="/flooring-services"
            element={<CommonServicePage currentService={ServicesAll[6]} />}
          />
          <Route
            path="/bathroom-fittings"
            element={<CommonServicePage currentService={ServicesAll[7]} />}
          />
          <Route
            path="/tiling-services"
            element={<CommonServicePage currentService={ServicesAll[8]} />}
          />
          <Route
            path="/groundwork-services"
            element={<CommonServicePage currentService={ServicesAll[9]} />}
          />
          <Route
            path="/kitchen-fitting-services"
            element={<CommonServicePage currentService={ServicesAll[10]} />}
          />
          <Route
            path="/electrical-works"
            element={<CommonServicePage currentService={ServicesAll[11]} />}
          />
          <Route
            path="/flat-refurbishment"
            element={<CommonServicePage currentService={ServicesAll[12]} />}
          />
          <Route
            path="/small-repairs"
            element={<CommonServicePage currentService={ServicesAll[13]} />}
          />
          <Route
            path="/building-maintenance"
            element={<CommonServicePage currentService={ServicesAll[14]} />}
          />
          <Route
            path="/landscaping-service"
            element={<CommonServicePage currentService={ServicesAll[15]} />}
          />
        </Route>
      </Routes>
    </Router>
  );
}
const ScrollHandler = () => {
  useScrollToTopOnRouteChange();
  return null;
};

export default App;
